import { useEffect, useState } from 'react'

import _ from 'lodash'

import { EditAdditionalInformation } from '@/features/user/additional-information/Edit'
import { useSessionContext } from '@/shared/hooks'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { useAvatarContext } from '@/shared/ui/Avatar'
import { AppMenuProfileTrigger, useAppMenu } from '@/shared/ui/Layout'

export const HeaderProfileArea = () => {
  const { user } = useSessionContext()
  const { userProgress, refetchProgress } = useUserProgress()
  const { hasAvatar, avatar } = useAvatarContext()
  const { setOnRequestEditAdditionalInfo, close } = useAppMenu()
  const [openEditInfo, setOpenEditInfo] = useState(false)

  const ticket = _.get(userProgress, 'user_tickets[0]')

  useEffect(() => {
    setOnRequestEditAdditionalInfo(() => () => {
      close()
      requestAnimationFrame(() => setOpenEditInfo(true))
    })

    return () => setOnRequestEditAdditionalInfo(null)
  }, [close, setOnRequestEditAdditionalInfo])

  return (
    <>
      <AppMenuProfileTrigger
        user={user}
        hasAvatar={hasAvatar}
        avatar={avatar}
      />

      {openEditInfo && ticket && (
        <EditAdditionalInformation
          openEditInfo={openEditInfo}
          setOpenEditInfo={setOpenEditInfo}
          id={ticket?.id}
          price_id={ticket?.price_id}
          additional_informations={ticket?.additional_informations}
          onSave={() => {
            setOpenEditInfo(false)
            refetchProgress()
          }}
        />
      )}
    </>
  )
}
